import { createTheme, alpha, lighten, darken } from '@material-ui/core/styles';
import type { Theme, ThemeOptions } from '@material-ui/core/styles/createTheme';

import { getDefaultClassOverrides } from 'themes/getTheme/defaultTheme';

// using createTheme here will populate other dynamic color values
// then we can use some of those dynamic values elsewhere in this file
const { palette: quantumPalette } = createTheme({
  palette: {
    contrastThreshold: 4.5, // AA a11y standards for text contrast ratio
    tonalOffset: 0.3, // AA a11y standards for focus contrast ratio (buttons)

    primary: {
      main: '#00205B',
      light: '#808FAD',
      dark: '#00102E',
    },
    secondary: {
      main: '#077DB1',
      dark: '#83BED8',
      light: '#043F59',
    },
    info: {
      main: '#077DB1',
    },
    success: {
      main: '#58BE8A',
    },
    warning: {
      main: '#ffcd00',
    },
    error: {
      main: '#F16664',
    },

    text: {
      primary: '#212121',
      secondary: '#6F6F6F',
    },

    /* **** Custom Colors **** */
    // focusIndicator: '#3e5b00',

    tertiary: {
      main: '#00205B',
      light: '#808FAD',
      dark: '#00102E',
      contrastText: '#ffffff',
    },

    rewards: {
      main: '#9F52CE',
      light: '#B275D8',
      dark: '#722C9D',
      contrastText: '#ffffff',
    },

    scoreTier: {
      1: '#357253',
      2: '#966F21',
      3: '#A94746',
    },
  },
});

function getQuantumClassOverrides(
  palette: Theme['palette'] = quantumPalette
): ThemeOptions['overrides'] {
  const defaultClassOverrides = getDefaultClassOverrides(palette);

  return {
    ...defaultClassOverrides,
    MuiTypography: {
      colorSecondary: {
        color: palette.primary.dark,
      },
    },
    MuiLink: {
      ...defaultClassOverrides?.MuiLink,
      root: {
        ...defaultClassOverrides?.MuiLink?.root,
        '&:visited': {
          color: palette.primary.light, // Override visited link color
        },
      },
    },
    MuiButton: {
      ...defaultClassOverrides?.MuiButton,

      containedSecondary: {
        ...defaultClassOverrides?.MuiButton?.containedSecondary,

        '&.card-details-button': {
          ...defaultClassOverrides?.MuiButton?.containedPrimary,
          color: palette.common.white,
          backgroundColor: palette.primary.main,
          '&:hover': {
            backgroundColor: palette.primary.dark,
          },

          '&$focusVisible': {
            outlineColor: lighten(palette.primary.main, 0.15),
            backgroundColor: darken(palette.primary.main, 0.3),
          },
        },
      },
    },
  };
}

const quantumThemeVariant: ThemeOptions = {
  palette: quantumPalette,
  typography: {},
  overrides: getQuantumClassOverrides(),
  props: {},
};

export default quantumThemeVariant;
